import { CalendarEvent, CalendarEventsType } from '../api/calendarEvent';
import { isPastDate } from '../design-system/DSCalendar/utils/calendarUtils';

export enum CalendarViewType {
  GRID = 'grid',
  LIST = 'list',
}

export const isNationalHoliday = (event: CalendarEvent): boolean => {
  return event.type.includes(CalendarEventsType.NATIONAL_HOLIDAY);
};

export const isCalendarEventPast = (event: CalendarEvent): boolean =>
  isPastDate(new Date(event.date.year, event.date.month - 1, event.date.day));
